import React from "react";
import { API, Storage } from "aws-amplify";

import {
  useNotify,
  useRedirect,
  Create,
  SaveButton,
  SimpleForm,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { logError } from "../../../utils/appUtils";
import { getDirFileKey } from "../../../utils/fileUtils";
import { FilePaths } from "../../../utils/constants";

import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { HelpButton } from "../../../components/common/HelpButton";
import { FileHelp } from "./FileHelp";
import { FileSetupTab } from "./FileSetupTab";

const FileCreateActions = ({ basePath, data, resource, ...props }) => (
  <TopToolbar>
    <HelpButton>
      <FileHelp {...props} />
    </HelpButton>
    <BackButton basePath={basePath} />
  </TopToolbar>
);

export const FileCreate = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();

  const transform = async (data) => {
    data = { ...data };
    try {
      debugger;
      const key = getDirFileKey(data.file.rawFile, FilePaths.DOCUMENTS);
      const response = await Storage.put(key, data.file.rawFile, {
        level: "public",
        contentType: data.file.rawFile.type,
      });

      if (response.key) {
        data.active = "true";
        data.groups = window.appUser?.groups;
        data.reloadYardId = window.appUser?.reloadYardId;
        data.rawFileName = data.file.rawFile.name;

        if (data.file.rawFile.lastModifiedDate)
          data.contentDate = data.file.rawFile.lastModifiedDate;

        data.file = {
          bucket: API._options.aws_user_files_s3_bucket,
          region: API._options.aws_user_files_s3_bucket_region,
          key: response.key,
        };
      } else throw new Error(`Storage.put failed: ${key}`);
    } catch (error) {
      logError("files:FileCreate:transform", error, notify);
      return Promise.reject();
    }

    delete data.fileCategories;

    return data;
  };

  const onSuccess = async (data) => {
    notify("File created successfully", "success");
    redirect("list", props.basePath);
  };

  const onFailure = (error) => {
    logError("files:FileCreate:onFailure", error, notify);
  };

  const FileCreateToolbar = (props) => (
    <Toolbar {...props}>
      <SaveButton
        label="Save"
        transform={transform}
        onSuccess={onSuccess}
        onFailure={onFailure}
      />
    </Toolbar>
  );

  return (
    <Create
      {...props}
      title={<ForceTitle title="New Document" />}
      actions={<FileCreateActions {...props} />}
    >
      <SimpleForm submitOnEnter={false} toolbar={<FileCreateToolbar />}>
        <FileSetupTab />
      </SimpleForm>
    </Create>
  );
};
